export const CampaignActions = { 
    CAMPAIGN_UTM_CODE : "CAMPAIGN_UTM_CODE",

    setCampaignUtmCode: (campaign_utm_code) => {
        return (dispatch) =>{
          dispatch({
            type: CampaignActions.CAMPAIGN_UTM_CODE,
            campaign_utm_code,
          })
        }
    }
}